import React, { useState } from "react"
import { css } from "@emotion/core"
import Projet from "../../../model/projet"
import { SubmitButton } from "../../generic/submit-button"
import { investmentService } from "../../../services/investment-service"
import { projetService } from "../../../services/projet-service"
import { ApplicationState } from "../../../store"
import { AuthenticationState } from "../../../store/authentication/types"
import { connect } from "react-redux"

type Props = {
    projet: Projet,
    loginProps : AuthenticationState,
    onSubmitSuccess: (response: Response) => void
}

function ProlongationForm({projet, loginProps, onSubmitSuccess}: Props) {
    const [errorMessage, setErrorMessage] = useState<string>("")
    const [isError, setIsError] = useState(false)

    const onSubmitError = (response : any) => {
        if (response.Error) {
            setIsError(true)
            setErrorMessage(response.Error);
        } else {
            setIsError(true)
            setErrorMessage("Il y a eu une erreur lors de l'upload")
        }
    }


    return (
        <>
            <div>
                En cliquant sur "Confirmer", la durée d'ouverture de la collecte sera prolongée de 10 jours
            </div>
            <div css={{textAlign: "center"}}>
                <SubmitButton 
                    label="Confirmer"
                    action={() => projetService.prolongationProjet(projet.Id!, loginProps.oauth)}
                    onPreSubmit= {() => {
                        setIsError(false)
                    }}
                    onActionSuccess={onSubmitSuccess}
                    onActionFailure={onSubmitError}
                />
                {isError && (
                    <div className="text-red-600">
                        {errorMessage}
                    </div>
                )}
            </div>
        </>
    )
}

const mapStateToProps = (state: ApplicationState) => ({
    loginProps: state.authentication,
  });

const ConnectedProlongationForm = connect(mapStateToProps)(ProlongationForm);
export {ConnectedProlongationForm as ProlongationForm}